import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import Modal from 'react-modal';
import {_delete, get, patch} from "../../../server/actions";
import{access_token} from "../../../server/constants";
import active from "../../../assets/img/active.png"
import NotificationSystem from 'react-notification-system';
import warn from "../../../assets/img/warning.png"
import deleted from "../../../assets/img/invalid.png"
import {BeatLoader} from 'react-spinners';
import ToggleDisplay from 'react-toggle-display';
import {_addNotification, _addNotificationError} from "../../../server/util";

let loggedUser = ''
//----Only for dev purpose
let mealSchoolId = "";
//------------------
/*let headerSchool = {
    marginBottom: '40px'
};*/
let adminData = '';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class SchoolList extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            expanded: {},
            schoolList: [],
            schoolData: [],
            currentPage: 0,
            deletedSchoolList: [],
            modalIsOpen: false,
            adminModalisOpen: false,
            show: false,
            search:''
        };
        this.previousPage = this.previousPage.bind(this);
        this.nextPage = this.nextPage.bind(this);

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    adminModal = (data, id) => {
        //alert(id)
        mealSchoolId = id;
        adminData = data;
        this.setState({adminModalisOpen: true})
    }
    filterSchoolList=()=>{
        let data=[];
        const {search, schoolData}=this.state;
        if(search.length > 0){
            schoolData.forEach(obj => {
                if((obj.sid).startsWith(search)){
                    data.push(obj);
                }
                else if (obj.schoolName != null && (obj.schoolName.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                }else if (obj.districtName != null && (obj.districtName.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                } else if (obj.subdomain != null && (obj.subdomain.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                } else if (obj.adminurl != null && (obj.adminurl.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                }
                else if (obj.schoolUsers != null) {
                    let x = false;
                    obj.schoolUsers.forEach(user => {
                        if (user.username.toLowerCase().startsWith(search.toLowerCase())) {
                            x = true;
                        }

                    });
                    x === true ? data.push(obj) : '';
                }
            });
        }else{
            data=schoolData;
        }
        this.setState({schoolList:data})
    }
    componentWillMount = () => {
        this.getSchoolList();
        loggedUser = sessionStorage.getItem('loggedInUserInfo') || '';
    };
    deactivateAdmin = () => {
        get('/enableDisableSchoolUser?schoolUserName=' + adminData.username + '&activeStatus=false&loggedUser=' + loggedUser + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification('Successfully deactivated admin.', this);
            this.getSchoolList();
            this.setState({
                loading: false,
                adminModalisOpen: false
            });
            console.log('Access Links Sent', data);
        })
            .catch(
                (error) => {
                    _addNotificationError('Deactivation failed. Please try again later.', this);
                    console.log('Send Notification Links response', error)
                }
            )
    }
    reactivateAdmin = () => {
        get('/enableDisableSchoolUser?schoolUserName=' + adminData.username + '&activeStatus=true&loggedUser=' + loggedUser + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification('Successfully reactivated admin.', this);
            this.getSchoolList();
            this.setState({
                loading: false,
                adminModalisOpen: false
            });
            console.log('Access Links Sent', data);
        })
            .catch(
                (error) => {
                    _addNotificationError('Deactivation failed. Please try again later.', this);
                    console.log('Send Notification Links response', error)
                }
            )
    }
    sendAdminLink = () => {
        //alert(mealSchoolId);
        get('/adminAccActivationInfo?schoolId=' + mealSchoolId + '&loggedUser=' + loggedUser + '&schoolUserName=' + adminData.username + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification('Successfully sent activation link.', this);
            this.setState({loading: false, adminModalIsOpen: false});

        })
            .catch(
                (error) => {
                    _addNotificationError('Failed to send activation link.', this);
                    console.log('Onboard School response', error)
                }
            )

    }
    sendAdminLinks = (col,username) => {
        console.log(JSON.stringify(col, null, 2))
        this.setState({loading: true});
        //alert(col._links.self.href.split('/').pop())
        let mealschoolid = col._links.self.href.split('/').pop();
        get('/adminAccActivationInfo?schoolId=' + mealschoolid + '&loggedUser=' + loggedUser +'&schoolUserName='+username+ '&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response;
            }).then(data => {
                _addNotification('Successfully sent emails.', this);
                this.setState({loading: false});
                console.log('Access Links Sent', data);
            }).catch(
                    (error) => {
                        _addNotificationError('Send links failed. Please try again later.', this);
                        console.log('Send Notification Links response', error)
                    });
    };
    getSchoolList = () => {
        this.state.schoolList = [];
        get('/mealSchools/search/findByIsActive?isActive=true&page=0&size=2147483647&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log('Json returned from getSchoolList', data);
            get('/getCountByCategory?category=Student&access_token=')
            .then(response=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            })
            .then(data1=>{
                //this.setState({schoolData: data._embedded.mealSchools});
              let protocal = window.location.protocol;
            let mainDomain =window.location.host.replace(window.location.host.split('.')[0],'');
            data._embedded.mealSchools.map(obj => {
                //alert(JSON.stringify(obj,null,2))
                const sid = obj._links.self.href.split('/').pop();
                obj.adminurl = protocal+'//'+ obj.subdomain  + mainDomain;
                obj.sid = sid
                const findObj = data1.response.find(item=> item.mealSchoolId == sid) || {}

                obj.districtName = findObj.districtName || ''
                obj.stdCount = findObj.stdCount || '';
                obj.catererName=findObj.catererName || '';
                return obj
                //obj.teacherurl = protocal + obj.schoolSubDomain + "." + mainDomain;
            })
            this.setState({
                schoolList: data._embedded.mealSchools,
                schoolData: data._embedded.mealSchools
            },()=>{
                this.filterSchoolList();
            });
        }).catch((err)=>{})
        })
            .catch(
                (error) => {
                    console.log('Get SchoolList response', error)
                }
            )

    };
    previousPage = () => {
        this.setState({currentPage: this.state.currentPage - 1})
    }
    nextPage = () => {
        //alert(this.state.currentPage)
        this.setState({currentPage: this.state.currentPage + 1})
    }
    deleteSchool = () => {
        this.setState({loading: true});
        _delete('/mealSchools/' + mealSchoolId + '?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification("School Deleted Successfully.", this)
            this.getSchoolList();
            this.setState({loading: false, modalIsOpen: false});

        })
            .catch(
                (error) => {
                    _addNotification("Delete task failed. Please try again later.", this)
                    this.setState({loading: false});
                    console.log('Delete School response', error)
                }
            )
    }
    handleClick = () => {
        this.getDeletedSchools();
        this.setState({
            show: !this.state.show
        })

    }
    getDeletedSchools = () => {
        this.state.deletedSchoolList = [];
        get('/mealSchools/search/findByIsActive?isActive=false&page=0&size=2147483647&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log('Json returned from getSchoolList', data);
            //   this.setState({schoolData: data._embedded.mealSchools});
            let protocal = window.location.protocol;
            let mainDomain =window.location.host.replace(window.location.host.split('.')[0],'');
            data._embedded.mealSchools.forEach(obj => {
                //alert(JSON.stringify(obj,null,2))
                obj.adminurl = protocal +'//'+ obj.subdomain + mainDomain;
                //obj.teacherurl = protocal + obj.schoolSubDomain + "." + mainDomain;
                this.setState({deletedSchoolList: [...this.state.deletedSchoolList, obj]});
            })
            console.log('SchoolList', this.state.deletedSchoolList);
        })
            .catch(
                (error) => {
                    console.log('Get SchoolList response', error)
                }
            )

    }
    restoreSchool = (col) => {
        this.setState({loading: true});
        let body = JSON.stringify({
            "isActive": true
        });
        let mealSchoolId = col._links.self.href.split('/').pop();
        patch('/mealSchools/' + mealSchoolId + '?access_token=', body).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            _addNotification("School restored Successfully.", this)
            this.getDeletedSchools()
            this.getSchoolList();
            this.setState({loading: false});


        })
            .catch(
                (error) => {
                    _addNotification("Restore task failed. Please try again later.", this)
                    this.setState({loading: false});
                    console.log('Restore School response', error)
                }
            )
    }
    

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    openModal(col) {
        //alert(JSON.stringify(col,null,2))
        mealSchoolId = col._links.self.href.split('/').pop();
        this.setState({modalIsOpen: true});

    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }
    getColumns=()=>{
        const columns = [
            {
                Header:'School Id',
                accessor:'sid',
                width: 100,
            },
        {
            Header: 'School',
            accessor: 'schoolName',
            width: 300,
            Cell:({row})=>{
                const sid=row._original._links.self.href.split('/').pop();
                return <Link to={"/superAdmin/regSchool/" + sid} className="text-info"
                onClick={this.props.editSchool.bind(this, row._original, "EDIT")}>{row._original.schoolName}</Link>
            }
          },
          {
            Header: 'SUB DOMAIN',
            accessor: 'subdomain',
            width: 200,
            Cell:({row})=>{
                return <div><strong>{row._original.subdomain}</strong> &nbsp; &nbsp;
                <a  href="javascript:void(0);" title="Admin URL" onClick={()=>{
                    const refresh_token = sessionStorage.getItem('refresh_token')||''
                    window.open(
                        `${row._original.adminurl}?${btoa(`akey=${access_token()}&rkey=${refresh_token}`)}`,
                        '_blank' // <- This is what makes it open in a new window.
                      );
                }}><i className="fa fa-external-link" style={{ fontSize:'18px'}} aria-hidden="true"></i></a>
                &nbsp; &nbsp;
                <a  href="javascript:void(0);" title="Copy url to clipboard" onClick={()=>{
                    const refresh_token = sessionStorage.getItem('refresh_token')||'';                    
                    const url= `${row._original.adminurl}?${btoa(`akey=${access_token()}&rkey=${refresh_token}`)}`;
                    window.navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
                        if (result.state == "granted" || result.state == "prompt") {
                            window.navigator.clipboard.writeText(url).then(() => {
                                /* Resolved - text copied to clipboard */
                                _addNotification("Url copied to clipboard", this);
                              },() => {
                                /* Rejected - clipboard failed */
                              }); 
                        }else{                            

                        }
                      });
                                      
                       
                }}><i className="fa fa-clipboard" style={{ fontSize:'18px'}} aria-hidden="true"></i></a>
                </div>
            }
          },
          {
            Header: 'DISTRICT NAME',
            accessor: 'districtName',
            width: 250            
          },
          {
            Header: 'CATERER NAME',
            accessor: 'catererName',
            width: 250
          },
          {
            Header: 'TOTAL STUDENTS',
            accessor: 'stdCount',
            width: 150
          },         
    {
        Header:'ACTION',
        width: 150,
        Cell:({row})=>{
            const sid=row._original._links.self.href.split('/').pop();
            return <Fragment>
            <Link to="/superAdmin/datasync" className="edit-btn"
                onClick={this.props.editSchool.bind(this, row._original, "SYNC")}><i
                className="fa fa-database tbl-rounded-icon bg-color-4 fa-icon"/></Link>
            <Link to={"/superAdmin/regSchool/" + sid} className="edit-btn"
                onClick={this.props.editSchool.bind(this, row._original, "EDIT")}><i
                className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon"/></Link>
            {/* <a onClick={() => this.sendAdminLinks(col)}><i
                className="fa fa-paper-plane-o tbl-rounded-icon bg-color-4 fa-icon"/></a> */}
            <a className="delete-btn" onClick={() => this.openModal(row._original)}><i
                className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon"/></a>
        </Fragment>

    }

    }
        ];
return columns
    }

    render() {
        const { toggleSelection, toggleAll, isSelected } = this;
        const checkboxProps = {
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold', textAlign:'right'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    style: {
                        margin: 'auto !important'
                    },
                    className: "table table-hover"
                }
            },
        };

        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>
                <section className=" full-width clearfix">
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container-full">
                    <div className="sectionTitle">
                        <h2>
                            <span>Schools</span>
                        </h2>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                            <input type="text" id="search" className="search form-control" value={this.state.search}
                                   name="search" placeholder="Search.." onChange={(e)=>{
                                    this.setState({search:e.target.value},()=>{
                                        this.filterSchoolList()
                                    });
                                   }} autocomplete='off'
                                   />
                        </div>
                        <div className="col-md-6" style={{marginTop:'10px'}}>
                            <label>{`Total Schools : ${this.state.schoolList.length}`}</label>
                        </div>
                        <div className="col-md-2 col-sm-6 col-xs-12 button-group-section form-group">
                            <Link className="btn btn-success button-sm add-btn-sm"
                                  id="addSchool" onClick={this.props.editSchool.bind(this, '', "NEW")}
                                  to="/superAdmin/regSchool"><i className="fa fa-plus"/> Add School</Link>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="table-responsive">
                                <Modal
                                    isOpen={this.state.adminModalisOpen}
                                    onAfterOpen={this.afterOpenModal}
                                    onRequestClose={() => {
                                        this.setState({adminModalisOpen: false})
                                    }}
                                    style={customStyles}
                                    contentLabel="Activation"
                                >
                                    <div className="modal-header act-de-modal-head">
                                        <h4 className="modal-title modal-title-color" id="deleteLabel">Manage Admin</h4>
                                    </div>
                                    <div className="modal-body text-center act-de-modal">                                        
                                        {adminData.isActive ? 
                                                <a class="btn btn-primary" href="javascript:void(0);"
                                                   onClick={this.deactivateAdmin}>Deactivate
                                                </a> : <a class="btn btn-info" href="javascript:void(0);"
                                                       onClick={this.reactivateAdmin}>Reactivate
                                        </a>}
                                    </div>
                                </Modal>
                                <Modal
                                    isOpen={this.state.modalIsOpen}
                                    onAfterOpen={this.afterOpenModal}
                                    onRequestClose={this.closeModal}
                                    style={customStyles}
                                    contentLabel="Activation"
                                >
                                    <div className="modal-header">
                                        <h4 className="modal-title modal-title-color" id="deleteLabel">Delete
                                            School</h4>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure you want to delete this school from Meal Manage service?<br/>
                                            <b><i>You can restore school again from deleted schools tab</i></b></p>
                                    </div>
                                    <div className="modal-footer">
                                        <form>
                                            <button type="button" className="btn btn-sm btn-success"
                                                    onClick={() => this.setState({modalIsOpen: false})}
                                                    style={{margin: 0, fontSize: 14}}><i
                                                className="glyphicon glyphicon-remove"/> Cancel
                                            </button>
                                            <button type="button" className="btn btn-sm btn-danger"
                                                    onClick={this.deleteSchool}
                                                    style={{margin: 0, marginLeft: 5, fontSize: 14}}><i
                                                className="glyphicon glyphicon-ok"/> Delete
                                            </button>
                                        </form>
                                    </div>
                                </Modal>                                
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                <div className="clearfix"></div>
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                        <ReactTable
                                                data={this.state.schoolList}
                                                expanded={this.state.expanded}
                                                columns={this.getColumns()}
                                                defaultPageSize={10}
                                                className="-striped -highlight"
                                                noDataText='No data found'
                                                sortable={true}
                                                defaultSorting={[{
                                                    id: 'session',
                                                    desc: false
                                                }]} 
                                                minRows = {1}
                                                {...checkboxProps}
                                                onExpandedChange={expandedList => {
                                                    const expanded = {}
                                                    Object.keys(expandedList).forEach(item => {
                                                        const expand = Boolean(expandedList[item] && expandedList[item].constructor === Object)
                                                        expanded[item] = expand
                                                    })
                                                    this.setState({ expanded })
                                                }}
                                                SubComponent={(row) => {
                                                    return (<div>
                                                        <div className="panel panel-default">
                                                            <div class="panel-heading">Admin Users</div>
                                                            <div className="panel-body">                                                                
                                                                <div className='row'>
                                                                    <div className='col-md-12'>
                                                                        <ul>
                                                                    {
                                                                    (row.original.schoolUsers.filter(user=>user.isPrimaryUser)).map(usr=>{
                                                                        return (<li>
                                                                            <span>
                                                                                <img alt="action"
                                                                                     onClick={() => this.adminModal(usr, row.original._links.self.href.split('/').pop())}
                                                                                     src={usr.isActive === true ? (usr.isVerified === true ? active : warn) : deleted}
                                                                                     style={{
                                                                                         paddingRight: '5px',
                                                                                         cursor: 'pointer',
                                                                                         width: '22px'
                                                                                     }}/>
                                                                                {usr.username}
                                                                                { usr.isVerified === true ?null: <a onClick={() => this.sendAdminLinks(row.original,usr.username)}><i
                                                                                className="fa fa-paper-plane-o" style={{ 'font-size':'14px',  'color':'#84bed6','padding': '5px','cursor':'pointer'}}  /></a>
                                                                                }
                                                                            </span>
                                                                        </li>)
                                                                    })
                                                                }</ul>

                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>)
                                                }} 
                                            />
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   {/*  <div className="text-right">
                        <ul className="pagination">
                            {this.state.currentPage > 0 &&
                            <li>
                                <button className="btn btn-primary " onClick={this.previousPage} type="button">Previous
                                </button>
                            </li>
                            }
                            {((this.state.currentPage + 1) * 5 < this.state.schoolList.length) &&
                            <li>
                                <button className="btn btn-success " onClick={this.nextPage} type="button">Next
                                </button>
                            </li>
                            }
                        </ul>
                    </div> */}
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <p className="App-intro">
                                <a href="javascript:void(0);"
                                   onClick={() => this.handleClick()}>Inactive schools
                                </a>
                            </p>

                            <ToggleDisplay show={this.state.show}>

                                <p><b><i> These are the inactive schools. Click on restore to undo the
                                    action.</i></b>
                                </p>
                                <div className="table-responsive ">
                                    <table className="table table-hover">
                                        <thead>
                                        <tr className="bg-success base-reverse">
                                            <th>SCHOOL NAME</th>
                                            <th>SUB DOMAIN</th>
                                            <th>URL</th>
                                            <th>ADMIN</th>
                                            <th>ACTION</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {
                                            this.state.deletedSchoolList.map(col =>
                                                <tr>
                                                    <td>{col.schoolName}</td>
                                                    <td>{col.subdomain}</td>
                                                    <td><a target="_blank" href={col.adminurl}>{col.adminurl} </a></td>
                                                    <td>{col.schoolUsers.map(user => {
                                                        return (<div>
                                                            <span>
                                                                {user.username}
                                                            </span>
                                                            </div>
                                                        );
                                                    })}</td>

                                                    <td className="actions text-center" style={{whiteSpace: 'nowrap'}}>
                                                        <div>
                                                            <a href="javascript:void(0);"
                                                               onClick={() => this.restoreSchool(col)}>Restore
                                                                service</a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        </tbody>
                                    </table>

                                </div>
                            </ToggleDisplay>
                        </div>
                    </div>
                </div>
                </section>
            </div>
            

        );
    }

}

export default SchoolList;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/SchoolList/schoolList.jsx